export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', color: 'accent', description: '激情澎湃的热血漫画' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', color: 'primary', description: '甜蜜动人的恋爱故事' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', color: 'secondary', description: '天马行空的奇幻世界' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', color: 'accent', description: '欢乐解压的搞笑漫画' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', color: 'primary', description: '扣人心弦的悬疑作品' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-flashlight-line', color: 'secondary', description: '紧张刺激的动作漫画' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', color: 'accent', description: '现代都市的情感故事' },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line', color: 'primary', description: '惊险刺激的恐怖漫画' },
];

export const comics = [
  {
    id: 1,
    slug: 'mitao-shaonian',
    title: '蜜桃少年',
    author: '樱桃工作室',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20teenage%20boy%20with%20soft%20peach%20pink%20hair%2C%20dreamy%20atmosphere%2C%20delicate%20watercolor%20style%2C%20romantic%20shoujo%20aesthetic%2C%20clean%20white%20background%2C%20soft%20pastel%20lighting%2C%20Korean%20webtoon%20cover%20art%20style%2C%20gentle%20expression%2C%20floating%20flower%20petals&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'lianai',
    rating: 9.6,
    views: 2856000,
    description: '蜜桃少年讲述了少年林桃在青春校园中的浪漫故事。他拥有一颗温柔的心，在友情与爱情的十字路口，他会如何抉择？甜蜜又带有一丝酸涩的青春物语，等你来品味。',
    chapters: 128,
    status: '连载中',
    updateDate: '2026-07-06',
    tags: ['校园', '青春', '纯爱', '治愈'],
    featured: true,
    trending: true,
  },
  {
    id: 2,
    slug: 'jiansheng-chuanshuo',
    title: '剑圣传说',
    author: '月影漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20illustration%20of%20a%20warrior%20with%20a%20massive%20sword%2C%20epic%20battle%20stance%2C%20flowing%20cape%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20strong%20silhouette%2C%20illustration%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'rexue',
    rating: 9.3,
    views: 1980000,
    description: '在这个剑与魔法的世界，少年楚天凭借一把神秘古剑，踏上成为最强剑圣的旅程。热血沸腾的战斗场面，扣人心弦的冒险故事。',
    chapters: 156,
    status: '连载中',
    updateDate: '2026-07-05',
    tags: ['奇幻', '冒险', '战斗', '成长'],
    featured: true,
    trending: true,
  },
  {
    id: 3,
    slug: 'xingkong-zhi-xia',
    title: '星空之下',
    author: '星河创作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20couple%20under%20starry%20night%20sky%2C%20romantic%20atmosphere%2C%20soft%20watercolor%20style%2C%20gentle%20embrace%2C%20Korean%20webtoon%20cover%20art%2C%20clean%20white%20background%20with%20subtle%20stars%2C%20dreamy%20lighting&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'lianai',
    rating: 9.5,
    views: 3200000,
    description: '仰望同一片星空的两个灵魂，注定会相遇。一段跨越时空的爱恋，在璀璨星河下缓缓展开。',
    chapters: 89,
    status: '连载中',
    updateDate: '2026-07-06',
    tags: ['浪漫', '星空', '奇幻爱情', '唯美'],
    featured: false,
    trending: true,
  },
  {
    id: 4,
    slug: 'mofa-xueyuan',
    title: '魔法学院',
    author: '幻境工坊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20magic%20academy%20student%20casting%20spells%2C%20colorful%20magical%20effects%2C%20school%20uniform%2C%20Korean%20webtoon%20style%2C%20vibrant%20colors%2C%20clean%20white%20background%2C%20dynamic%20pose&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'qihuan',
    rating: 9.1,
    views: 1560000,
    description: '平凡少女夏琳意外收到魔法学院的录取通知书，从此开启了不可思议的魔法之旅。友情、成长与冒险交织的奇幻校园故事。',
    chapters: 112,
    status: '连载中',
    updateDate: '2026-07-04',
    tags: ['魔法', '校园', '奇幻冒险', '成长'],
    featured: true,
    trending: false,
  },
  {
    id: 5,
    slug: 'gaoxiao-richang',
    title: '搞笑日常',
    author: '欢乐豆漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20of%20a%20funny%20chibi%20character%20making%20silly%20face%2C%20bright%20colorful%20style%2C%20humorous%20expression%2C%20Korean%20webtoon%20comedy%20art%2C%20clean%20white%20background%2C%20playful%20vibe&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'gaoxiao',
    rating: 9.0,
    views: 4100000,
    description: '四个性格迥异的室友在同一屋檐下发生的各种爆笑日常。每一话都能让你笑出腹肌！',
    chapters: 200,
    status: '连载中',
    updateDate: '2026-07-06',
    tags: ['搞笑', '日常', '校园', '轻松'],
    featured: false,
    trending: true,
  },
  {
    id: 6,
    slug: 'heiye-zhentan',
    title: '黑夜侦探',
    author: '暗影工作室',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20illustration%20of%20a%20detective%20in%20trench%20coat%2C%20dark%20atmosphere%2C%20noir%20style%2C%20dramatic%20shadow%20lighting%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20mysterious%20mood&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'xuanyi',
    rating: 9.4,
    views: 1890000,
    description: '顶尖私家侦探林墨，接手了一桩看似普通的失踪案，却意外卷入一场惊天阴谋。层层迷雾背后，真相究竟为何？',
    chapters: 67,
    status: '连载中',
    updateDate: '2026-07-03',
    tags: ['悬疑', '推理', '犯罪', '都市'],
    featured: false,
    trending: false,
  },
  {
    id: 7,
    slug: 'juezhan-dingfeng',
    title: '决战巅峰',
    author: '雷霆漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fighting%20illustration%20of%20a%20martial%20artist%20in%20dynamic%20fighting%20pose%2C%20intense%20battle%20scene%2C%20Korean%20webtoon%20style%2C%20powerful%20energy%20effects%2C%20clean%20white%20background%2C%20strong%20impact&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'dongzuo',
    rating: 9.2,
    views: 2340000,
    description: '地下格斗界的传奇王者，为了守护珍视之人重返擂台。拳拳到肉的真实格斗，让你感受肾上腺素飙升的快感。',
    chapters: 98,
    status: '连载中',
    updateDate: '2026-07-05',
    tags: ['格斗', '热血', '竞技', '兄弟情'],
    featured: false,
    trending: false,
  },
  {
    id: 8,
    slug: 'chengshi-guangying',
    title: '城市光影',
    author: '都市绘梦',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20illustration%20of%20a%20young%20professional%20in%20modern%20city%2C%20warm%20lighting%2C%20urban%20romance%20vibe%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20sophisticated%20mood&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'dushi',
    rating: 8.9,
    views: 1450000,
    description: '在大城市打拼的年轻人，在钢筋水泥的丛林中寻找属于自己的光。温暖治愈的都市情感故事。',
    chapters: 55,
    status: '已完结',
    updateDate: '2026-06-30',
    tags: ['都市', '职场', '情感', '现实主义'],
    featured: false,
    trending: false,
  },
  {
    id: 9,
    slug: 'lingyi-biji',
    title: '灵异笔记',
    author: '午夜画师',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20illustration%20of%20a%20mysterious%20shadow%20figure%2C%20eerie%20atmosphere%2C%20dark%20moody%20lighting%2C%20Korean%20webtoon%20horror%20style%2C%20clean%20white%20background%20with%20dark%20vignette%2C%20creepy%20vibe&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'kongbu',
    rating: 9.0,
    views: 1120000,
    description: '大学生陈浩拥有看见鬼魂的能力，一本古老的笔记将他卷入一系列超自然事件。胆小慎入！',
    chapters: 42,
    status: '连载中',
    updateDate: '2026-07-01',
    tags: ['恐怖', '灵异', '超自然', '悬疑'],
    featured: false,
    trending: false,
  },
  {
    id: 10,
    slug: 'yongzhe-zhi-hun',
    title: '勇者之魂',
    author: '星辰漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20illustration%20of%20a%20young%20hero%20with%20shining%20armor%2C%20epic%20fantasy%20style%2C%20Korean%20webtoon%20art%2C%20heroic%20stance%2C%20clean%20white%20background%2C%20inspiring%20mood&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'qihuan',
    rating: 9.3,
    views: 2100000,
    description: '被选中的少年艾瑞克，继承了远古勇者的灵魂，踏上了拯救王国的史诗冒险之路。',
    chapters: 134,
    status: '连载中',
    updateDate: '2026-07-06',
    tags: ['冒险', '奇幻', '史诗', '英雄'],
    featured: true,
    trending: true,
  },
  {
    id: 11,
    slug: 'huakai-shijie',
    title: '花开时节',
    author: '花瓣工坊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20girl%20surrounded%20by%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20soft%20pink%20tones%2C%20Korean%20webtoon%20shoujo%20style%2C%20clean%20white%20background%2C%20gentle%20romantic%20mood&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'lianai',
    rating: 9.4,
    views: 1780000,
    description: '樱花盛开的季节，转校生小樱遇见了改变她一生的那个人。纯爱满分，治愈力MAX。',
    chapters: 76,
    status: '连载中',
    updateDate: '2026-07-06',
    tags: ['校园', '纯爱', '治愈', '春季'],
    featured: false,
    trending: true,
  },
  {
    id: 12,
    slug: 'tieshi-quanjishi',
    title: '铁石拳击手',
    author: '铁拳漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20boxing%20illustration%20of%20a%20determined%20boxer%20in%20the%20ring%2C%20intense%20expression%2C%20dynamic%20action%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20powerful%20athletic%20vibe&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'dongzuo',
    rating: 9.1,
    views: 1670000,
    description: '从小在贫民区长大的少年，凭借一双铁拳打出了属于自己的天地。热血励志拳击物语。',
    chapters: 88,
    status: '连载中',
    updateDate: '2026-07-04',
    tags: ['拳击', '热血', '励志', '竞技'],
    featured: false,
    trending: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20young%20woman%2C%20soft%20features%2C%20warm%20expression%2C%20simple%20white%20background%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-test-01&orientation=portrait',
    quote: '蜜桃少年真的太好看了！画风精美，剧情甜度满分，每天等更新已经成了我的日常。073漫画网的阅读体验也非常流畅！',
    verified: true,
    rating: 5,
  },
  {
    id: 2,
    name: '小明',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20young%20man%2C%20friendly%20smile%2C%20simple%20white%20background%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-test-02&orientation=portrait',
    quote: '我朋友推荐我来073漫画网看韩国漫画的，没想到一入坑就停不下来了。分类很齐全，更新也快，强烈推荐剑圣传说！',
    verified: true,
    rating: 5,
  },
  {
    id: 3,
    name: '小花',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20young%20woman%20with%20glasses%2C%20intellectual%20look%2C%20simple%20white%20background%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-test-03&orientation=portrait',
    quote: '作为一个看了十年漫画的老读者，073漫画网的漫画质量确实高。页面干净无广告干扰，是我用过最好的免费漫画平台。',
    verified: true,
    rating: 5,
  },
];

export const siteInfo = {
  name: '073漫画网',
  nameEn: '073 Manhua',
  domain: '073manhua.com',
  email: 'support@073manhua.com',
  phone: '400-888-0730',
  address: '中国广东省广州市天河区体育西路123号',
  founded: '2023',
  description: '073漫画网成立于2023年，致力于为广大漫画爱好者提供高质量、完全免费的韩国漫画阅读服务。我们与多家韩国知名漫画工作室合作，为用户带来最新、最热的漫画作品。',
  mission: '我们的使命是让每一位漫画爱好者都能无障碍地享受优质漫画内容。073漫画网始终坚持免费阅读的理念，通过技术创新不断提升阅读体验。',
};